import ImageModalReducer from "../reducers/ImageModalReducer";
import BaseAction from "./BaseAction";

class ImageModalAction extends BaseAction {
  open = async (image, title = "Image") => {
    this.dispatch({ open: true, image, title });
  };
}

const action = new ImageModalAction(ImageModalReducer);

export default action;
